let id:number = parseInt(window.localStorage.getItem('_maxId')||'0')||0
function createId(){
    const newId=id++
    window.localStorage.setItem('_maxId',newId.toString())
    return newId
}
export default createId
